import { FormControl, Grid, InputLabel, MenuItem, Select } from "@mui/material";
import { useEffect, useRef } from "react";
import { searchAssignedCompanies } from "../store/slices/userRequests";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../store";

interface MySelectAssignedCompanyProps {
    includeAllCompaniesOption?: boolean;
    allCompaniesOptionValue?: string;
    rucSelected: string;
    setRucSelected: (ruc: string) => void;
    // setCompanySelectedData?: 
    minWidth?: string;
}

const MySelectAssignedCompany = ({
    includeAllCompaniesOption,
    allCompaniesOptionValue,
    rucSelected, 
    setRucSelected,
    minWidth,
}: MySelectAssignedCompanyProps) => {

    const dispatch = useDispatch<AppDispatch>();
    const {companyselected, connectionId} = useSelector((state: RootState) => state.auth);
    const {assignedCompanies} = useSelector((state: RootState) => state.userRequests);
    const {companiesIsLoading,} = useSelector((state: RootState) => state.userRequests).approvalGroups;

    const requestedRef = useRef(false);

    useEffect(() => {
        if (!connectionId || !companyselected?.Token || companiesIsLoading || assignedCompanies.length || requestedRef.current === true) {
            return;
        }
        requestedRef.current = true;
        dispatch(searchAssignedCompanies());
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [companyselected?.Token, connectionId])

    useEffect(() => {
        if (companiesIsLoading || rucSelected) {
            return
        }
        setRucSelected(
            allCompaniesOptionValue !== undefined
                ? allCompaniesOptionValue
                : assignedCompanies.length
                    ? assignedCompanies[0].RUCEmpresa
                    : ""
        )
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [companiesIsLoading, assignedCompanies])

    if (companiesIsLoading) {
        return <></>;
    }

    console.log(assignedCompanies)

    return (
        <Grid item>
            <FormControl style={{minWidth: minWidth || "15rem"}}>
                <InputLabel id="select-option-label">Empresa</InputLabel>
                <Select
                    labelId="select-option-label"
                    id="select-option"
                    label={"Empresa"}
                    onChange={(event: { target: { value: string } }) => {
                        const value = event.target.value;
                        setRucSelected(value);
                    }}
                    value={rucSelected}
                    style={{height: "2.5rem", border: "none", backgroundColor: "white"}}
                >
                    {includeAllCompaniesOption && 
                        <MenuItem 
                            value={allCompaniesOptionValue || ""}
                        >
                            Todas las empresas
                        </MenuItem>
                    }
                    {assignedCompanies?.map((item, i) => (
                        <MenuItem
                            key={i} 
                            value={item.RUCEmpresa}
                        >
                            {item.DescripcionEmpresa}
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>
        </Grid>
    )
}

export default MySelectAssignedCompany;